export default __webpack_public_path__ + "static/media/notes-app-2.5e471871.webp";